import { Box, useMediaQuery } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import React from 'react';
import Section from '../../../shared/Section/Section';
import EventsBlockCard from '../../../shared/EventsBlockCard/EventsBlockCard';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';
import EventsMobileBlockCard from '../../../shared/EventsBlockCard/EventsMobileBlockCard';

const preLoadedEvents = [
  { isLoading: true },
  { isLoading: true },
  { isLoading: true },
];

const normalizeStartTime = (event) => {
  if (Array.isArray(event.startTime)) {
    event.startTime.length = 1;
  }
  return event;
};

const installYandexMetrics = (event, idx) => {
  event.ymClickEventType =
    idx === 0 ? 'mainEventsFirstRequest' : 'mainEventsSecondRequest';
  event.ymSubmitEventType =
    idx === 0 ? 'mainEventsFirstConfirm' : 'mainEventsSecondConfirm';
  return event;
};

const transformData = (data) =>
  data.map(normalizeStartTime).map(installYandexMetrics);

function Events({
  title,
  subtitle,
  events = [],
  blockRef,
  cardBullits,
  ymEvents,
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const eventsData = transformData(events);
  const currentEvents = events.length > 0 ? eventsData : preLoadedEvents;
  const isDesignEvent = (event) => {
    return event?.titleEnum?.includes('_UX');
  };
  return (
    <Section
      subtitle={subtitle}
      title={title}
      theme="light"
      anchor="events"
      withoutBg
    >
      <Box ref={blockRef} />
      <Box
        sx={{
          display: 'flex',
          gap: { xs: 2, lg: 3 },
          flexDirection: { xs: 'column', lg: 'row' },
          alignItems: 'center',
        }}
      >
        {isSm &&
          currentEvents.map((event, idx) => (
            <EventsMobileBlockCard
              {...event}
              key={idx}
              cardBullits={
                isDesignEvent(event)
                  ? cardBullits.design
                  : cardBullits[event.format]
              }
              ymEvent={ymEvents[event.titleEnum]}
            />
          ))}
        {!isSm &&
          currentEvents.map((event, idx) => (
            <EventsBlockCard
              {...event}
              key={idx}
              cardBullits={
                isDesignEvent(event)
                  ? cardBullits.design
                  : cardBullits[event.format]
              }
              ymEvent={ymEvents[event.titleEnum]}
            />
          ))}
      </Box>
      <Box sx={{ mt: { xs: 3, lg: 5 } }}>
        <Link
          variant="kitPrimary"
          href="/events/"
          onClick={() => sendYandexMetrikaEvent(ymEvents.ymEventClick)}
        >
          Посмотреть все события
        </Link>
      </Box>
    </Section>
  );
}

export default Events;
